<script setup lang="ts">
    import { injectorAccessInjectionKey } from '@cwd/lib/provider-keys';
    import { ContextAccess } from '@shared/Root/Context.access';
    import BsAlert from '@shared/components/BsAlert.vue';
    import { AlertTypes } from '@shared/components/BsAlerts';
    import { inject } from 'vue';

    const injectorAccess = inject(injectorAccessInjectionKey)!;
    const contextAccess: ContextAccess = injectorAccess.injector.get(ContextAccess);

    const redirectToPaymentFailed = () => {
        window.location.href = '/Account/PaymentFailed';
    };

    const statusPaymentFailed = 6;
</script>

<template>
    <template v-if="contextAccess.state.currentAccount">
        <BsAlert
            :show="contextAccess.state.currentAccount.ServiceSubscriptionStatus === statusPaymentFailed"
            :type="AlertTypes.Danger"
            :title="$Resources.AccountPaymentFailedHeading"
            :content="$Resources.AccountPaymentFailedBody"
            :button-text="$Resources.AccountPaymentFailedButton"
            :dismissible="false"
            @button-click="redirectToPaymentFailed" />

        <BsAlert
            :show="contextAccess.state.currentAccount.AccountCancelled"
            :type="AlertTypes.Danger"
            :title="$Resources.AccountCancelledHeading"
            :content="$Resources.AccountCancelledBody"
            :dismissible="false" />
    </template>
</template>
